// «Сегодня»: всё вместе. Блок без данных рисует своё пустое состояние и не ломает экран.

import { useState } from 'react'

import { PageHeader } from '@/components/layout'
import { Button, ErrorText, PageSpinner } from '@/components/ui'
import { formatDayTitle } from '@/lib/format'
import { useActiveSession } from '@/offline/activeSession'

import { AdviceButton } from './AdviceButton'
import { useToday } from './api'
import { GarminSyncButton } from './GarminSyncButton'
import {
  Checklist,
  ConditionsBlock,
  GoalsBlock,
  PlanBlock,
  ReadinessBlock,
  SleepBlock,
  StepsBlock,
  SupplementsBlock,
  WeightBlock,
  WellbeingBlock,
} from './parts'
import { QuickEntry, type QuickKind } from './QuickEntry'

export function TodayPage() {
  const today = useToday()
  const { session } = useActiveSession()
  const [quick, setQuick] = useState<QuickKind | null>(null)
  const title = formatDayTitle(new Date())

  const data = today.data
  return (
    <>
      <PageHeader
        title="Сегодня"
        description={title.charAt(0).toUpperCase() + title.slice(1)}
        actions={
          <>
            <GarminSyncButton />
            <AdviceButton />
            <Button icon="plus" onClick={() => setQuick('weight')} disabled={!data}>
              Быстрый ввод
            </Button>
          </>
        }
      />
      {today.isLoading ? <PageSpinner /> : null}
      {today.error && !data ? <ErrorText error={today.error} /> : null}
      {data ? (
        <div className="flex flex-col gap-4">
          <Checklist onboarding={data.onboarding} />
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <div className="min-w-0 md:col-span-2 xl:col-span-3">
              <PlanBlock plan={data.plan} active={session} />
            </div>
            <SleepBlock sleep={data.sleep} />
            <ReadinessBlock data={data.readiness} />
            <StepsBlock data={data.steps} />
            <WeightBlock data={data.weight} onAdd={() => setQuick('weight')} />
            <WellbeingBlock data={data.wellbeing} onAdd={() => setQuick('wellbeing')} />
            <GoalsBlock goals={data.goals} />
            <ConditionsBlock conditions={data.conditions} />
            <SupplementsBlock day={data.day} supplements={data.supplements} />
          </div>
          {quick ? <QuickEntry open onClose={() => setQuick(null)} day={data.day} initial={quick} /> : null}
        </div>
      ) : null}
    </>
  )
}
